import React, { useMemo } from 'react';
import { Select } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';

const QUERY = gql`
  query {
    surveyCategories { id title }
  }
`;

const SurveyCategorySelect = (props) => {
  const { loading, data: { surveyCategories = [] } = {} } = useQuery(QUERY, {
    fetchPolicy: 'cache-first',
  });

  const options = useMemo(() => surveyCategories.map(c => ({ value: c.id, label: c.title })), [surveyCategories]);

  return (
    <Select loading={loading} options={options} showSearch optionFilterProp="label" {...props} />
  );
};

export default SurveyCategorySelect;
